import {
  AuthenticatedUser,
  IResource,
  Office,
  ResourceType
} from '@gettactic/api';
import { isAllowedToReserve } from './isAllowedToReserve';
import { canScheduleOthers } from '../permissions';

export interface IsResourceAvailableOptions {
  authenticatedUser: any;
  officeTimeZone: string;
  office: Office;
  resourceType: ResourceType;
  allowReserveOnBehalf: boolean;
  meetingsDisabled: boolean;
  startDate: Date;
}

export const isResourceAvailable = (
  authenticatedUser: AuthenticatedUser,
  resource: IResource,
  options?: IsResourceAvailableOptions
) => {
  const allowReserveOnBehalf = canScheduleOthers(authenticatedUser);
  const { meetingsDisabled, resourceType, office, officeTimeZone, startDate } =
    options || {};
  if (!resourceType || !startDate) return false;
  const allowReserveByMaxDate = isAllowedToReserve(
    startDate,
    officeTimeZone || '',
    office,
    resourceType,
    authenticatedUser.user?.organization_user?.roles
  );

  if (!resource || !resource.is_available) {
    return false;
  }
  // If the user can reserve on behalf of others, we need to be able to trigger the reserve modal
  // with the resource pre-selected.
  if (allowReserveOnBehalf) {
    return true;
  }

  return (
    allowReserveByMaxDate &&
    resource.available_slots > 0 &&
    (resource.type !== 'meeting_room' || !meetingsDisabled)
  );
};
